export default "__VITE_ASSET__BCbF9GEY__"